import React from 'react';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
import { Check, ArrowRight } from 'lucide-react';
export function HeroSection() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 sm:px-6 lg:px-8 bg-slate-900 overflow-hidden" data-id="element-45">
      {/* Background Gradient */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none" data-id="element-46">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl" data-id="element-47" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-indigo-500/10 rounded-full blur-3xl" data-id="element-48" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-49">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-50">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} className="text-left" data-id="element-51">
            <div className="inline-flex items-center px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-400 text-sm font-medium mb-6" data-id="element-52">
              <span className="flex h-2 w-2 rounded-full bg-blue-400 mr-2 animate-pulse" data-id="element-53"></span>
              Sistema de Disciplina en 7 Días
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6" data-id="element-54">
              Domina tu Disciplina en Trading{' '}
              <span className="text-blue-500" data-id="element-55">en 7 Días</span>
            </h1>

            <p className="text-lg md:text-xl text-slate-300 mb-8 leading-relaxed max-w-2xl" data-id="element-56">
              Deja de operar por impulso (FOMO, sobreoperación y revenge) y
              empieza a ejecutar con reglas claras y una rutina simple — sin
              cambiar de estrategia.
            </p>

            <ul className="space-y-4 mb-10" data-id="element-57">
              {['Menos impulsos, más control', 'Reglas claras para entrar / no entrar', 'Protocolo post‑pérdida para cortar el revenge', 'Rutina diaria de 10 minutos', 'Aplicable a crypto, forex, índices o acciones'].map((item, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              delay: 0.2 + index * 0.1
            }} className="flex items-start text-slate-300" data-id="element-58">
                  <div className="flex-shrink-0 h-6 w-6 rounded-full bg-blue-500/20 flex items-center justify-center mr-3 mt-0.5" data-id="element-59">
                    <Check className="h-4 w-4 text-blue-400" data-id="element-60" />
                  </div>
                  {item}
                </motion.li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center" data-id="element-61">
              <Button size="lg" href="https://www.claridaddirecta.com/cart/57813856682365:1" className="w-full sm:w-auto group" data-id="element-62">
                Comprar ahora — 17€
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-63" />
              </Button>
              <p className="text-sm text-slate-400 mt-2 sm:mt-0 sm:ml-4" data-id="element-64">
                <span className="block text-slate-300 font-medium" data-id="element-65">
                  Descarga inmediata
                </span>
                Ebook PDF + bonos imprimibles
              </p>
            </div>
          </motion.div>

          {/* Image Content */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative mx-auto lg:mx-0" data-id="element-66">
            <div className="relative rounded-2xl bg-slate-800/50 p-4 border border-slate-700/50 backdrop-blur-sm shadow-2xl" data-id="element-67">
              <img src="https://cdn.magicpatterns.com/uploads/kKXiBFhAkXGX3Mn1FXtJih/heylloyd-image-1770926679436.png" alt="Anti FOMO Trader Ebook Mockup" className="w-full h-auto rounded-lg shadow-lg" data-id="element-68" />

              {/* Floating Badge */}
              <motion.div initial={{
              y: 20,
              opacity: 0
            }} animate={{
              y: 0,
              opacity: 1
            }} transition={{
              delay: 1,
              duration: 0.5
            }} className="absolute -bottom-6 -right-6 bg-slate-800 border border-slate-700 p-4 rounded-xl shadow-xl hidden md:block" data-id="element-69">
                <div className="flex items-center gap-3" data-id="element-70">
                  <div className="flex -space-x-2" data-id="element-71">
                    {[1, 2, 3].map(i => <div key={i} className="w-8 h-8 rounded-full bg-slate-600 border-2 border-slate-800 flex items-center justify-center text-xs font-bold" data-id="element-72">
                        {String.fromCharCode(64 + i)}
                      </div>)}
                  </div>
                  <div className="text-sm" data-id="element-73">
                    <p className="font-bold text-white" data-id="element-74">Trader verificado</p>
                    <p className="text-slate-400 text-xs" data-id="element-75">Sistema probado</p>
                  </div>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}